import React from 'react';
import VKSimpleCell, { SimpleCellProps } from '@vkontakte/vkui/dist/components/SimpleCell/SimpleCell';
import { styled } from '@material-ui/styles';

export default styled(VKSimpleCell)({
  '& .SimpleCell__children': {
    wordBreak: 'break-word',
  },
}) as React.FC<SimpleCellProps>;
